// extracted by mini-css-extract-plugin
export default {"fab":"WhatsAppFab_fab__9LVGq","icon":"WhatsAppFab_icon__KcK4j"};